export default "__VITE_ASSET__BWbbEHb4__"